import {
    CloseIcon,
    DesignTokens,
    GivelifyButton,
    GivelifyIcon,
} from '@givelify/ui';
import { styled } from '@mui/material';

export const TitleWrapper = styled('div')({
    flex: 1,
});

export const ProgressWrapper = styled('div')(({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('lg')]: {
        maxWidth: 240,
    },
}));

export const DragZone = styled('div')(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 40,
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'normal',
        gap: 16,
    },
}));

export const DragZoneMobile = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});

export const Wrapper = styled('div', {
    shouldForwardProp: (prop) =>
        prop !== 'active' && prop !== 'error' && prop !== 'mobile',
})<{ active?: boolean; error?: boolean; mobile?: boolean }>(
    ({ theme, active, error, mobile }) => ({
        display: 'flex',
        flexDirection: 'row',
        boxShadow: DesignTokens.shadow.shadowMedium,
        minHeight: 104,
        paddingLeft: 32,
        paddingRight: 32,
        gap: 60,
        borderRadius: 4,
        border: '1px solid transparent',
        borderColor: error
            ? DesignTokens.color.borderComponentError
            : 'transparent',
        '&:hover': {
            cursor: active ? 'pointer' : 'initial',
        },
        ...(mobile
            ? {
                  padding: theme.spacing(4, 3),
                  gap: 0,
                  flexDirection: 'row',
                  minHeight: 0,
              }
            : {}),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            paddingTop: 24,
            paddingBottom: 24,
            gap: 16,
        },
    }),
);

export const Handle = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

export const Controls = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 24,
});

export const Switch = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});

export const ErrorMessage = styled('div')({
    backgroundColor: DesignTokens.color.backgroundComponentError,
    padding: '5px 24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
});

export const CloseErrorIcon = styled(CloseIcon)({
    color: DesignTokens.color.iconPrimary,
    cursor: 'pointer',
});

export const EnvelopeListIcon = styled(GivelifyIcon)({
    fontSize: '24px',
});

export const EnvelopeListCheckmarkIcon = styled(EnvelopeListIcon)({
    '@keyframes myAnimation': {
        '20%': { transform: 'scale(1)' },
        '50%': {
            transform: 'scale(1.2)',
        },
        '100%': { transform: 'scale(1)' },
    },
    color: 'transparent',
    animation: 'myAnimation 1s',
});

export const EditButton = styled(GivelifyButton)(({ theme }) => ({
    fontSize: '16px',
    '&.Mui-disabled': {
        background: 'none',
    },
    '& .MuiButton-icon': {
        fill: DesignTokens.color.iconDisabled,
    },
    [theme.breakpoints.down('mobile')]: {
        fontSize: '16px',
    },
}));
